<ng-container *transloco="let t">
    <div class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-6 h-full"
    *ngIf="chartOptions">
        <div class="flex items-start justify-between">
            <div class="text-lg font-medium tracking-tight leading-6 truncate">{{ t(titleKey) }}</div>
            <div *ngIf="selectablePeriods?.length" class="ml-2">
                <button
                    class="h-6 min-h-6 px-2 rounded-full bg-hover"
                    mat-button
                    [matMenuTriggerFor]="periodMenu">
                    <span class="font-medium text-sm text-secondary">{{selectedPeriod.isTranslationKey ? (selectedPeriod.label | transloco) : selectedPeriod.label}}</span>
                </button>
                <mat-menu #periodMenu="matMenu">
                    <button *ngFor="let item of selectablePeriods"
                            mat-menu-item
                            (click)="periodChanged(item)">
                            {{item.isTranslationKey ?  (item.label | transloco) : item.label}}
                    </button>
                </mat-menu>
            </div>
        </div>
        <div class="block mt-6 h-48">
            <apx-chart
            *ngIf="chartOptions?.chart"
                class="flex flex-auto items-center justify-center w-full h-full"
                [chart]="chartOptions.chart"
                [colors]="chartOptions.colors"
                [labels]="chartOptions.labels"
                [plotOptions]="chartOptions.plotOptions"
                [series]="chartOptions.series"
                [states]="chartOptions.states"
                [tooltip]="chartOptions.tooltip"></apx-chart>
        </div>
        <div class="mt-8">
            <div *ngIf="!hasValues()" class="-my-3 divide-y">
                <ng-container *ngFor="let series of tableData?.series; let i = index">
                    <div class="grid grid-cols-5 py-3">
                        <div class="flex items-center col-span-4">
                            <div
                                class="flex-0 w-2 h-2 rounded-full"
                                [style.backgroundColor]="chartOptions.colors[i]"></div>
                            <div class="ml-3 truncate" [matTooltip]="tableData.labels[i]">{{tableData.labels[i]}}</div>
                        </div>

                        <div class="text-right text-secondary col-span-1">{{series > 1 || series === 0 ? (series | number: '1.0-1') : "< 1"}}%</div>
                    </div>
                </ng-container>
            </div>
            <div *ngIf="hasValues()" class="-my-3 divide-y">
                <ng-container *ngFor="let series of tableData?.series; let i = index">
                    <div class="grid grid-cols-6 py-3">
                        <div class="flex items-center col-span-3">
                            <div
                                class="flex-0 w-2 h-2 rounded-full"
                                [style.backgroundColor]="chartOptions.colors[i]"></div>
                            <div class="ml-3 truncate" [matTooltip]="tableData.labels[i]">{{tableData.labels[i]}}</div>
                        </div>
                        <div class="text-right text-secondary col-span-2">{{tableData.values[i]}}</div>
                        <div class="text-right text-secondary col-span-1">{{series > 1 || series === 0 ? (series | number: '1.0-1') : "< 1"}}%</div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
